export default __webpack_public_path__ + "b5329103e193298fe15efe1d4eeb9e31.woff";